{% block moorl_cms_slot_card %}
    <mt-card
        class="moorl-cms-slot-card"
        :title="$tc('moorl-cms-slot-card.name')"
    >
        <sw-cms-slot
            :key="item.id"
            :element="item"
            :disabled="false"
            :active="true"
        />
    </mt-card>
{% endblock %}